import { FirestoreClient } from '../../../types'
import { getTaskRef } from '../get/getTaskRef'
import { FirestoreAdmin } from '../../../types/FirestoreAdmin'

interface Props<T extends FirestoreClient | FirestoreAdmin> {
  firestore: T
  teamId: string
  taskId: string
}

export const deleteTask = <T extends FirestoreClient | FirestoreAdmin>({
  firestore,
  teamId,
  taskId,
}: Props<T>): T extends FirestoreClient
  ? Promise<any>
  : Promise<FirebaseFirestore.WriteResult> => {
  return getTaskRef({
    firestore,
    teamId,
    taskId,
  }).delete() as any
}
